<template>
    <div class="login">
<!--        <div class="left_box" v-if="show.loginPublic">-->
<!--            <div>-->
<!--                <h3>经&nbsp;&nbsp;销&nbsp;&nbsp;商&nbsp;&nbsp;系&nbsp;&nbsp;统</h3>-->
<!--                <p>上海昱熙科技提供技术支持</p>-->
<!--                <div>-->
<!--                    <el-image-->
<!--                        fit="cover"-->
<!--                        style="width:160px;height:160px;"-->
<!--                        :src="src.src_check"-->
<!--                    >-->
<!--                        <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">-->
<!--                            <div class="el_image">-->
<!--                                <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div slot="error" class="image-slot"  style="width:100%;height:100%;">-->
<!--                            <div class="el_image">-->
<!--                                <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </el-image>-->
<!--                    <h6>安卓版APP下载</h6>-->
<!--                </div>-->
<!--            </div>-->
<!--            <el-image-->
<!--                fit="cover"-->
<!--                style="width:100%;height:100%;display:block;"-->
<!--                :src="src.src_bg"-->
<!--            >-->
<!--                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:26px"></span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div slot="error" class="image-slot"  style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-image>-->
<!--        </div>-->
<!--        <div class="right_box" v-if="show.loginPublic">-->
<!--            <el-image-->
<!--                fit="cover"-->
<!--                style="width:134px;height:134px;"-->
<!--                :src="src.src_logo"-->
<!--            >-->
<!--                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div slot="error" class="image-slot"  style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-image>-->
<!--            <ul>-->
<!--                <li>-->
<!--                    <label for="">公司域</label>-->
<!--                    <el-input v-model="input.input1" placeholder="请输入公司域"  clearable></el-input>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <label for="">账&nbsp;&nbsp;&nbsp;&nbsp;号</label>-->
<!--                    <el-input v-model="input.input2" placeholder="请输入账号" autocomplete="on"  clearable></el-input>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <label for="">密&nbsp;&nbsp;&nbsp;&nbsp;码</label>-->
<!--                    <el-input placeholder="请输入密码" v-model="input.input3" autocomplete="on"  show-password></el-input>-->
<!--                </li>-->
<!--                <li><button  @click="login" :disabled="isLoading"><i v-show="isLoading" class="iconfont icon-jiazai"></i>&nbsp;登陆</button></li>-->
<!--            </ul>-->
<!--        </div>-->

<!--        <div v-if="show.loginSTDQ" class="forSTDQ">-->
            <div class="forSTDQ">
            <div class="forSTDQ_Form">
                <div class="forSTDQ_img">
                    <img :style="{width:'68px',height:'68px'}" src="../assets/img/vip@2x.png"/>
                </div>
                <ul class="forSTDQ_CONTENT">
                    <li class="forSTDQ_welcome">
                        系统登录
                    </li>
                    <li>
                        当前系统已停用==>
                        <a href="http://qlt.yuximi.com/#/logon">点击跳转到最新系统</a>
                    </li>
<!--                    <li :style="{display:'none'}">-->
<!--                        <label for="">公司域</label>-->
<!--                        <el-input v-model="input.input1" placeholder="请输入公司域"  clearable></el-input>-->
<!--                    </li>-->
                    <!-- <li :style="{marginBottom:'10px'}"> -->
                        <!-- <label for="">账&nbsp;&nbsp;&nbsp;&nbsp;号</label> -->
                        <!-- <el-input v-model="input.input2" placeholder="手机号/账号" autocomplete="on"  clearable></el-input>
                    </li> -->
                    <!-- <li :style="{marginBottom:'10px'}"> -->
                        <!-- <label for="">密&nbsp;&nbsp;&nbsp;&nbsp;码</label> -->
                        <!-- <el-input v-if="!switch_login" placeholder="密码" v-model="input.input3" autocomplete="on"  show-password></el-input>
                        <el-input v-else-if="switch_login" placeholder="验证码" v-model="input.input4" autocomplete="on" >
                            <template slot="append"  >
                                <div v-if="!count_down" class="appendBg"  @click="countdownAction">
                                    获取验证码
                                </div>
                                <div v-else-if="count_down">
                                    {{count_down_text}}
                                </div>
                            </template>
                        </el-input>
                    </li>
                  <li>
                        <div @click="switchLogin" style="fontSize:10px;margin-top: 10px;margin-bottom: 10px; width: 50%;"><i v-if="!switch_login">手机验证码登录</i><i v-else-if="switch_login">账号密码登录</i></div>
                    </li>
                    <li>
                        <button :style="{width:'100%',height:'32px',background:'#4E5771',color:'#ffffff',border:'0',borderRadius:'5px',cursor:'pointer'}" @click="login" :disabled="isLoading"><i v-show="isLoading" class="iconfont icon-jiazai"></i> 登陆</button>
                    </li>
                    <li :style="{textAlign:'center',marginTop:'20px'}">
                        <img :style="{width:'120px',height:'120px'}" src="../assets/img/app_stdq_jxs.png"/>
                        <div :style="{textAlign:'center',fontSize:'14px'}">APP下载</div>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import crypto from 'crypto';

import src_check from '@/assets/img/check.png'
import src_logo from '@/assets/img/logo@2x.png'
import src_bg from '@/assets/img/1@2x.jpg'
import src_err from '@/assets/img/err.png'

export default {
    // name:"login",
    data(){
        return {
            src:{
                src_check,
                src_logo,
                src_bg,
                src_err
            },
            switch_login: true,
            count_down: false,
            count_down_text: "倒计时(60)",
            input:{
                // 域名
                input1: '',
                // 用户名
                input2: '',
                // 密码
                input3: '',
                //验证码
                input4: '',
            },
            show: {
                loginPublic: false,
                loginSTDQ: false,
            },
            // 登录加载
            isLoading:false
        }
    },
    methods:{
        countdownAction(){
            this.count_down = !this.count_down;
            this.loginCode();
            var time = 60;
            var timer = null;
            timer = setInterval(()=>{
                if(time == 1){
                    clearInterval(timer);
                    this.count_down = !this.count_down;
                }else{
                    time--;
                 this.count_down_text = '倒计时('+time+')'
                }
            }, 1000)
        },
        switchLogin(){
            this.switch_login = !this.switch_login;
        },
        login(){
            this.isLoading=true
            if (!this.switch_login){
                this.phoneLogin();
            }else{
                this.countDownLogin();
            }

        },
        countDownLogin(){
            this.$http({
                url: 'login_in',
                data: {
                    mobile:this.input.input2,
                    code:this.input.input4,
                    login_method: '1',
                },
            }).then(res=>{
                this.isLoading=false
                if(res.code==1){
                    this.$message({
                        message:`${res.msg}`,
                        type: 'success'
                    });
                    console.log('验证码登录');
                    console.log(res.data);
                    window.localStorage.setItem("yu_name",this.input.input1)
                    this.$store.commit({
                        type:'set_userInfo',
                        data:res.data
                    })
                    this.$router.push('/')
                }
            }).catch((err)=> {
                this.isLoading=false
                console.log(err)
            });
        },
        phoneLogin(){
            this.$http({
                url: 'login',
                data: {
                    company_yu:this.input.input1,
                    username:this.input.input2,
                    password:crypto.createHash('md5').update(this.input.input3).digest('hex')
                },
            }).then(res=>{
                this.isLoading=false
                if(res.code==1){
                    this.$message({
                        message:`${res.msg}`,
                        type: 'success'
                    });
                    console.log('手机账号登录');
                    console.log(res.data);
                    window.localStorage.setItem("yu_name",this.input.input1)
                    this.$store.commit({
                        type:'set_userInfo',
                        data:res.data
                    })
                    this.$router.push('/')
                }
            }).catch((err)=> {
                this.isLoading=false
                console.log(err)
            });
        },
        loginCode(){
            this.$http({
                url: 'accept_sms_code',
                data: {
                    mobile:this.input.input2,
                },
            }).then(res=>{
                this.isLoading=false
                if(res.code==1){
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                }
            }).catch((err)=> {
                this.isLoading=false
                console.log(err)
            });
        },
    },

    created(){
        if(window.localStorage.getItem("yu_name")){
            this.input.input1=window.localStorage.getItem("yu_name")
        }
    },
    mounted(){
        console.log(window.location.href);
        console.log(crypto.createHash('md5').update('z46373').digest('hex'));
        if(window.location.href.indexOf("vip.stdq.com")>-1){
        // if(window.location.href.indexOf("223")>-1){
            // console.log("vip.stdq.com");
            this.show.loginSTDQ = true;
        }else{
            // console.log("public");
            this.show.loginPublic = true;
        }
        this.show.loginSTDQ = true;
        this.show.loginPublic = false;

        // this.show.loginSTDQ = true;
        // this.show.loginPublic = false;
    }
}
</script>
<style lang="scss" scoped>
    .appendBg{
        /*background-color: #409eff;*/
        color: #409eff;
    }
.forSTDQ{
    width: 100%;
    background: url('../assets/img/bg_stdq.png') center center no-repeat;
    background-size: 100% 100%;
}
.forSTDQ_Form{
    // background: #ffffff;
    // background-color:transparent;
    background-color: rgba(255,255,255,0.75);
    padding: 30px;
    border-radius: 6px;
    width: 380px;
    margin: 0 auto;
    position: relative;
    top: 30%;
}
.forSTDQ_img{
    text-align: center;
    margin-bottom: 20px;
    position: absolute;
    top: -34px;
    left: 41%;
}
.forSTDQ_CONTENT{
    padding-top: 20px;
}
.forSTDQ_welcome{
    padding-bottom: 20px;
    text-align: center;
    font-weight: bold;
}

.login{
    display:flex;
    height:100%;
    /*box-sizing:border-box;*/
    /*padding-top:110px;*/
    min-height:100%;
}
.left_box{
    width:65%;
    height:100%;
    position:relative;
    >div:first-child{
        position:absolute;
        top:40px;
        left:40px;
        color:white;
        z-index:3000;
        h3{
            font-size:28px;
            line-height:50px;
        }
        p{
            font-size:18px;
            margin-bottom:60px;
        }
        >div{
            display:inline-block;
            h6{
                text-align:center;
                font-size:14px;
                line-height:40px;
            }
        }
    }
}
.right_box{
    width:35%;
    min-width:520px;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
    >ul{
        width:520px;
        margin:100px auto 0;
        >li{
            display:flex;
            align-items:center;
            padding:15px 0;
            margin:0 30px;
            border-bottom:1px solid #DDDDDD;
            label{
                display:block;
                width:50px;
                min-width:50px;
                margin-right:20px;
            }
        }
        >li:last-child{
            border:none;
            margin-top:50px;
            padding:0;
            border-radius:6px;
            button{
                display:block;
                width:100%;
                padding:15px 0;
                color:white;
                cursor:pointer;
                border-radius:6px;
                background:#FF9933;
                outline: none;
                border:none;
                .icon-jiazai{
                    display:inline-block;
                    width:20px;
                    animation:loading 1.5s linear infinite;
                }
            }
        }
    }
}
@keyframes loading {
    0% {transform:rotate(0deg);}
    50% {transform:rotate(180deg);}
    100% {transform:rotate(360deg);}
}
</style>
<style scoped>
.right_box >>> .el-input__inner{
    border:none;
}
</style>
